<template>
  <div v-if="showNoDataImgForUser">
    <div class="progressImgDataContainer">
      <div class="progressDataText">
        <h4>Your data has been successfully added to Weavr!</h4>
        <p>Please check back in 24 hours.</p>
      </div>
      <div class="progressImgWrapper">
        <img
          src="Icons_SVG/progressDataImgUpdated.svg"
          alt="data in progress"
        />
      </div>
    </div>
  </div>
  <div v-else id="sovindia4page">
    <div
      data-html2canvas-ignore="true"
      v-show="
        loader ||
        loader0 ||
        loader2 ||
        loader3 ||
        loader4 ||
        loader5 ||
        loader6 ||
        loader7 ||
        loader8 ||
        loader9 ||
        getbrandLoader ||
        loaderUpdated ||
        loaderStatus ||
        sosInsightsLoader ||
        excelDownloadLoader
      "
    >
      <Loader />
    </div>

    <div class="datepickerwrap card">
      <div class="d-flex justify-content-between align-items-center flex-wrap">
        <div class="d-flex align-items-center flex-wrap" style="gap: 5px">
          <div>
            <div
              class="mb-1"
              style="font-size: 13px; font-weight: 400; color: #1e1e1e"
            >
              {{ translatedLang["Date Range"][selectedLanguage.key] }}
            </div>
            <date-range-picker
              v-model="dateRange"
              :show-dropdowns="true"
              opens="right"
              :autoApply="true"
              :locale-data="{ format: 'dd mmm yyyy' }"
              :min-date="minDate"
              :max-date="maxDate"
            >
            </date-range-picker>
          </div>
          <div
            class="customMultiselectCommon"
            style="margin-top: -4px; min-width: 170px; max-width: 200px"
            v-if="Object.keys(viewPlatformAndCategoryData).length"
          >
            <div
              class="mb-1 ml-1"
              style="font-size: 13px; font-weight: 400; color: #1e1e1e"
            >
              {{ translatedLang["Platform"][selectedLanguage.key] }}
            </div>
            <!-- <select @change="changedWebsite" v-model="selected_website_sos" class="form-control text-capitalize">
              <option :value="website.platform_link" v-for="website of viewPlatformAndCategoryData.platform"
                :key="website.platform_name" class="text-capitalize">
                {{ website.platform_name.replaceAll("_", " ") }}
              </option>
            </select> -->
            <multiselect
              @input="changedWebsite"
              :custom-label="updateSelectedLabels"
              v-model="selected_website_sos"
              :options="
                viewPlatformAndCategoryData.platform.filter(
                  (items) =>
                    viewPlatformAndCategoryData.search[items.platform_id]
                ) || []
              "
              :multiple="false"
              :searchable="false"
              placeholder="Select Platform"
              label="platform_name"
              track-by="platform_link"
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
              class="text-capitalize"
            >
              <template #option="{ option }">
                <div class="custom-option text-capitalize">
                  {{ option.platform_name.replaceAll("_", " ") }}
                </div>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon"
            style="margin-top: -2px; min-width: 170px; max-width: auto"
            v-if="Object.keys(viewPlatformAndCategoryData).length"
          >
            <div
              class="mb-1 ml-1"
              style="font-size: 13px; font-weight: 400; color: #1e1e1e"
            >
              {{ translatedLang["Search Term"][selectedLanguage.key] }}
            </div>
            <!-- <select v-model="selectedItemCategory" class="form-control text-capitalize">
              <option v-for="d in itemCategory" :value="d" :key="d.key" class="text-capitalize">
                {{ d.value }}
              </option>
            </select> -->
            <multiselect
              @change="categoryChange"
              label="value"
              track-by="key"
              v-model="selectedItemCategory"
              class="text-capitalize"
              :options="itemCategory || []"
              :multiple="false"
              :searchable="false"
              placeholder="Select Category"
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
            >
            </multiselect>
          </div>

          <!-- sub category -->
          <div
            class="mb-1"
            style="margin-top: -3px; width: 200px"
            v-if="
              Object.keys(viewPlatformAndCategoryData).length &&
              storeSubCategory.options.length !== 0
            "
          >
            <div
              class="mb-1 ml-1"
              style="font-size: 13px; font-weight: 400; color: #1e1e1e"
            >
              {{ translatedLang["Sub Category"][selectedLanguage.key] }}
            </div>
            <!-- @input="handleSelectionChange" -->
            <treeselect
              class="text-capitalize"
              v-model="storeSubCategory.selectedSubCategory"
              :options="storeSubCategory.options"
              value-consists-of="LEAF_PRIORITY"
              :disable-branch-nodes="true"
              placeholder="Select Sub Category"
              :multiple="true"
              :searchable="true"
            >
              <span slot="noResult">{{
                translatedLang["No elements found"][selectedLanguage.key]
              }}</span>
            </treeselect>
          </div>
          <!-- brands -->
          <div
            class="customMultiselectCommon"
            style="margin-top: -2px; width: 160px"
            v-if="Object.keys(viewPlatformAndCategoryData).length"
          >
            <div
              class="mb-1 ml-1"
              style="font-size: 13px; font-weight: 400; color: #1e1e1e"
            >
              {{ translatedLang["Brand"][selectedLanguage.key] }}
            </div>
            <!-- <select v-model="storeSelectedBrandName" class="form-control text-capitalize">
              <option v-for="d in storeAllBrands" :value="d" :key="d.key" class="text-capitalize">
                {{ d }}
              </option>
            </select> -->
            <multiselect
              v-model="storeSelectedBrandName"
              class="text-capitalize"
              :options="storeAllBrands || []"
              :multiple="false"
              track-by="key"
              label="value"
              :searchable="false"
              placeholder="Select Brand"
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
            >
              <template #option="{ option }">
                <div class="custom-option text-capitalize">
                  {{ option.value }}
                </div>
              </template>
            </multiselect>
          </div>
          <div class="ml-lg-2 mt-3">
            <button @click="filterApply" class="btn primarycolor">
              {{ translatedLang["Apply Filters"][selectedLanguage.key] }}
            </button>
          </div>
          <!-- <div class="d-lg-none mt-3">
            <b-button size="sm" @click="goToDetailPage" class="navigationButton">Show Details
            </b-button>
          </div> -->
        </div>
        <div class="">
          <b-button
            size="sm"
            @click="sosCountReportApi"
            class="mr-2 btn primarycolor"
            >{{ translatedLang["Download"][selectedLanguage.key] }}
          </b-button>
          <b-button
            size="sm"
            v-if="Object.keys(viewPlatformAndCategoryData).length"
            @click="goToDetailPage"
            class="navigationButton"
            >{{ translatedLang["Show Details"][selectedLanguage.key] }}
          </b-button>
        </div>

        <!-- <div class="lastUpdated">
            Last Updated: {{ lastUpdated }}
          </div> -->
      </div>
    </div>
    <div class="container-fluid" style="margin-top: 10px">
      <div class="row" id="sov-bar-charts">
        <div class="col-12 col-md-6" style="padding-right: 2px">
          <div class="col-md-12" style="padding-left: 2px">
            <div class="card">
              <div
                style="align-items: center"
                class="space-between-header flex-wrap borderBetween pb-4"
              >
                <p class="graphHeading">
                  {{ translatedLang["Search SOS"][selectedLanguage.key] }} :
                  <span class="text-dark text-capitalize">{{
                    tempSelectedItemCategory.value
                  }}</span>
                </p>
              </div>
              <div ref="chartContainer">
                <highcharts
                  :options="charts"
                  v-if="searchSosDataShow"
                  ref="chart"
                ></highcharts>
                <div
                  v-else-if="!searchSosDataShow && loader9"
                  class="onLoadingData"
                >
                  {{ translatedLang["Loading"][selectedLanguage.key] }}...
                </div>
                <div
                  v-else
                  class="text-danger d-flex justify-content-center border border-danger rounded mt-1 p-2 noData"
                >
                  {{
                    translatedLang["No Data Available"][selectedLanguage.key]
                  }}.
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-12" style="padding-left: 2px">
              <div class="card">
                <div class="space-between-header flex-wrap borderBetween pb-4">
                  <p class="graphHeading">
                    Search SOV :
                    <span class="text-dark text-capitalize">{{
                      tempSelectedItemCategory.value
                      }}</span>
                  </p>
                </div>
                <div ref="searchChartContainer">
                  <highcharts :options="charts_sos" v-if="activeChart" ref="searchChart"></highcharts>
                  <div v-else
                    class="text-danger d-flex justify-content-center border border-danger rounded mt-1 p-2 noData">
                    No Data Available.
                  </div>
                </div>
              </div>
            </div> -->
          <div class="col-md-12" style="padding-left: 2px">
            <div class="card">
              <div class="space-between-header borderBetween pb-4">
                <p class="graphHeading">
                  {{ translatedLang["Position SOS"][selectedLanguage.key] }}:
                  <span class="text-dark text-capitalize">{{
                    tempSelectedItemCategory.value
                  }}</span>
                </p>
              </div>
              <div ref="columnChartContainer"  v-if="positionSosBarDataShow">
                <highcharts
                  :options="searchGraph"
                  v-if="positionSosBarDataShow"
                  ref="columnChart"
                >
                </highcharts>
              </div>
                <div
                  v-else-if="!positionSosBarDataShow && loader8"
                  class="onLoadingData"
                >
                  {{ translatedLang["Loading"][selectedLanguage.key] }}...
                </div>
                <div
                  v-else
                  class="text-danger d-flex justify-content-center border border-danger rounded mt-1 p-2 noData"
                >
                  {{
                    translatedLang["No Data Available"][selectedLanguage.key]
                  }}.
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 mycols">
          <div
            class="card"
            :style="{
              'max-height': '339px',
              'min-height': sosInsightsDataShow ? '339px' : 'auto',
            }"
          >
            <div class="space-between-header borderBetween pb-4">
              <p class="graphHeading">
                {{ translatedLang["Insights"][selectedLanguage.key] }} :
                <!-- <span class="text-dark text-capitalize">{{
                    tempSelectedItemCategory.value
                    }}</span> -->
              </p>
            </div>
            <!-- <h1 class="d-flex justify-content-center" style="
                padding: 100px 0;
                height: 100%;
                width: 100%;
                color: rgb(6, 85, 89);
              ">
              Coming Soon!
            </h1> -->
            <div
              v-if="sosInsightsDataShow"
              style="overflow-y: auto"
              class="thin-scrollerBar pr-1 pt-1"
            >
              <div
                class="inSightsContainer d-flex"
                v-for="(insight, index) in storeSOSInsights"
                :class="[storeSOSInsights.length - 1 !== index && 'mb-3']"
              >
                <div
                  class="col-1 d-flex justify-content-center align-items-center flex-column"
                >
                  <p class="mb-0" style="color: #00555a; font-weight: 400">
                    {{
                      new Date(insight.date).toLocaleString("en-US", {
                        month: "short",
                      })
                    }}
                  </p>
                  <p
                    class="mb-0"
                    style="font-size: 20px; font-weight: 600; color: #5e5e5e"
                  >
                    {{ new Date(insight.date).getDate() }}
                  </p>
                </div>
                <div class="col-11 pt-2 pb-3">
                  <p
                    class="insightsContent mb-2"
                    v-html="insight.description"
                  ></p>
                  <div class="flex mt-3">
                    <span class="borderCommonForTag px-2 py-1 mr-2">{{
                      insight.platform
                    }}</span>
                    <span class="borderCommonForTag px-2 py-1 mr-2">{{
                      insight.category
                    }}</span>
                    <!-- <span class="border rounded px-2 py-1 mr-2">category</span> -->
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else-if="!sosInsightsDataShow && sosInsightsLoader"
              class="onLoadingData"
            >
              {{ translatedLang["Loading"][selectedLanguage.key] }}...
            </div>
            <div
              v-else
              class="text-danger d-flex justify-content-center border border-danger rounded mt-1 p-2 noData"
            >
              {{ translatedLang["No Data Available"][selectedLanguage.key] }}.
            </div>
          </div>
          <div class="card" id="sov-trendline">
            <div
              class="space-between-header align-items-center justify-content-between flex-wrap borderBetween p-0"
              style="
                margin-top: -3px !important;
                padding-bottom: 9px !important;
              "
            >
              <!-- <div style="align-items: center"> -->
              <p class="graphHeading longHeadingWidth">
                {{ translatedLang["Position SOS"][selectedLanguage.key] }} :
                <span
                  v-if="tempSelectedItemCategory.value"
                  class="text-dark text-capitalize"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  :title="tempSelectedItemCategory.value"
                >
                  {{ tempSelectedItemCategory.value }}
                </span>
              </p>
              <!-- </div> -->
              <div style="display: flex; align-items: center; flex-wrap: wrap">
                <div class="dropdown-width">
                  <!-- <div class="mb-1 pl-4" style="font-size: 13px; font-weight: 400; color: #1e1e1e">
                                        Page No.
                                    </div> -->
                  <select
                    v-model="selectedPageTrendline"
                    @change="getTrendline"
                    style="margin-right: 10px; width: 73%; font-weight: 800"
                    class="form-control text-uppercase"
                  >
                    <option value="1">
                      {{ translatedLang["Page"][selectedLanguage.key] }} : 1
                    </option>
                    <option value="1-4">
                      {{ translatedLang["Pages"][selectedLanguage.key] }} : 1-4
                    </option>
                  </select>
                </div>
                <div>
                  <div style="margin-top: 0">
                    <b-button-toolbar
                      class="float-right"
                      aria-label="Toolbar with buttons group"
                    >
                      <b-form-radio-group
                        class="radiohide"
                        id="radiosBtn"
                        buttons
                        button-variant="outline-secondary"
                        v-model="sovInterval"
                        name="radiosBtn"
                      >
                        <b-form-radio
                          class="mx-0"
                          style="padding: 0 8px !important"
                          value="day"
                          >{{
                            translatedLang["Day"][selectedLanguage.key]
                          }}</b-form-radio
                        >
                        <b-form-radio
                          class="mx-0"
                          style="padding: 0 8px !important"
                          value="week"
                          >{{
                            translatedLang["Week"][selectedLanguage.key]
                          }}</b-form-radio
                        >
                        <b-form-radio
                          class="mx-0"
                          style="padding: 0 8px !important"
                          value="month"
                          >{{
                            translatedLang["Month"][selectedLanguage.key]
                          }}</b-form-radio
                        >
                        <b-form-radio
                          class="mx-0"
                          style="padding: 0 8px !important"
                          value="year"
                          >{{
                            translatedLang["Year"][selectedLanguage.key]
                          }}</b-form-radio
                        >
                      </b-form-radio-group>
                    </b-button-toolbar>
                  </div>
                </div>
              </div>
            </div>
            <div ref="lineChartContainer">
              <highcharts
                style="width: 100%"
                :options="daywiseChart"
                v-if="positionSOSTrendLineDataShow"
                ref="lineChart"
              >
              </highcharts>
              <div
                v-else-if="!positionSOSTrendLineDataShow && loader7"
                class="onLoadingData"
              >
                {{ translatedLang["Loading"][selectedLanguage.key] }}...
              </div>
              <div
                v-else
                class="text-danger d-flex justify-content-center border border-danger rounded mt-1 p-2 noData"
              >
                {{ translatedLang["No Data Available"][selectedLanguage.key] }}.
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="card" v-if="customClient != 'agepha' && customClient != 'rr' && customClient != 'haier' && customClient != 'bata'">
            <h4 class="graphHeading">
              Trend for <span style="text-transform: capitalize">{{ customClient }}</span>
              {{ selectedItemCategory.value }} count
            </h4>
            <div>
              <highcharts style="width: 100%" :options="daywiseAMDCount"></highcharts>
            </div>
          </div> -->
      <!-- <div class="card" id="reviews-section">
          <div class="space-between-header mb-0 pb-0">
            <h3></h3>
            <div style="display: inherit">
              <div @click="showProductModal" style="display: flex; cursor: pointer; text-transform: capitalize">
                <div style="
                      height: 35px;
                      border: none;
                      background: var(--primary_brand);
                      color: white;
                      border-radius: 5px;
                      font-weight: 600;
                      padding: 0px 25px;
                      display: flex;
                      align-items: center;
                      letter-spacing: 0.2px;
                    ">
                  Products
                </div>
                <div style="
                      background: white;
                      padding-left: 14px;
                      border: 1px solid var(--primary_brand);
                      border-radius: 5px;
                      margin-left: -5px;
                      padding-right: 14px;
                    ">
                  <span style="
                        margin-top: 7px;
                        float: left;
                        font-size: 12px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        max-width: 201px;
                      " v-if="selectedProduct">{{ selectedProduct.toUpperCase() }}
                  </span>
                </div>
              </div>
              <div class="datePickerBadge" style="padding-left: 6px">From</div>
              <datepicker placeholder="From" @input="refreshReview" v-model="reviewStartDate" />
              <div class="datePickerBadge" style="padding-left: 6px">To</div>
              <datepicker v-model="reviewEndDate" class="picker-left" placeholder="To" @input="refreshReview" />
              <div @click="goToReview" style="margin-left: 6px">
                <b-button size="sm" class="navigationButton">Show Reviews</b-button>
              </div>
            </div>
          </div>
          <div class="borderBetween"></div>
          <div style="margin-bottom: 4px">
            <div class="space-between-header">
              <h4 class="graphHeading">Total Reviews: {{ totalReviewCount | format }}</h4>
              <div>
                <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                  <b-form-radio-group class="radiohide" id="radiosBtn" buttons button-variant="outline-secondary"
                    v-model="revInterval" name="radiosBtn">
                    <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                    <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                    <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                  </b-form-radio-group>
                </b-button-toolbar>
              </div>
            </div>
            <highcharts :options="reviewGraph" v-if="activeReviewGraph && !loader"></highcharts>
            <div style="margin: 15px"></div>
            <highcharts :options="creviewGraph" v-if="activeReviewGraph && !loader"></highcharts>
          </div>
          <div class="borderBetween"></div>
          <div v-if="!loader">
            <div class="space-between-header">
              <h4 class="graphHeading">Avg. Rating: {{ ratingAvg }}</h4>
              <div style="display: flex">
                <b-button-toolbar aria-label="Toolbar with buttons group">
                  <b-form-radio-group class="radiohide" id="radiosBtn" buttons button-variant="outline-secondary"
                    v-model="revInterval" name="radiosBtn">
                    <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                    <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                    <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                  </b-form-radio-group>
                </b-button-toolbar>
              </div>
            </div>
            <highcharts :options="ratingGraph" v-if="activeRatingGraph"></highcharts>
            <div style="margin: 15px"></div>
            <highcharts :options="cratingGraph" v-if="activeReviewGraph"></highcharts>
            <p style="
                  text-align: center;
                  font-size: 12px;
                  font-weight: 600;
                  color: var(--primary_brand);
                  text-transform: initial;
                ">
              Cumulative Rating = Cumulative Sum of Ratings / Cumulative Sum of Reviews
            </p>
          </div>
        </div> -->
      <div class="card">
        <div
          class="d-flex justify-content-between align-items-center mb-3"
          style="
            border-bottom: 0.13rem solid rgb(221, 221, 221);
            margin-top: -3px;
            padding-bottom: 9px;
          "
        >
          <h3 class="graphHeading">
            {{ translatedLang["SOS Listing"][selectedLanguage.key] }}
          </h3>
          <div class="d-flex align-items-end">
            <div class="dropdown-width">
              <div
                class="mb-1"
                style="font-size: 13px; font-weight: 400; color: #1e1e1e"
              >
                {{ translatedLang["Page No"][selectedLanguage.key] }}.
              </div>
              <select
                @change="getPie"
                style="margin-right: 10px; width: 89%; font-weight: 800"
                v-model="selectedPage"
                class="form-control text-uppercase"
              >
                <option value="1">
                  {{ translatedLang["Page"][selectedLanguage.key] }} : 1
                </option>
                <option value="1-4">
                  {{ translatedLang["Pages"][selectedLanguage.key] }} : 1-4
                </option>
              </select>
            </div>
            <b-button
              size="sm"
              v-if="Object.keys(viewPlatformAndCategoryData).length"
              @click="goToDetailPage"
              class="navigationButton"
            >
              {{ translatedLang["Show Details"][selectedLanguage.key] }}
            </b-button>
          </div>
        </div>

        <div class="row">
          <div class="col-6" style="border-right: 1px solid #ddd">
            <div class="" id="category-data">
              <div
                class="space-between-header flex-wrap mb-0 pb-0"
                style="align-items: center"
              >
                <h3 class="graphHeading" style="margin-bottom: 0px !important">
                  <span class="text-dark"
                    >{{ translatedLang["Top 5 Brands"][selectedLanguage.key] }}
                  </span>
                </h3>
                <div class="d-flex">
                  <!-- <div class="dropdown-width">
                                    <div class="mb-1" style="font-size: 13px; font-weight: 400; color: #1e1e1e">
                                        Page No.
                                    </div>
                                    <select @change="getPie" style="margin-right: 10px; width: 97%"
                                        v-model="selectedPage" class="form-control text-uppercase">
                                        <option value="1">Page : 1</option>
                                        <option value="1-4">Pages : 1-4</option>
                                    </select>
                                </div> -->
                  <!-- <div style="width: 170px">
                    <div class="mb-1" style="font-size: 13px; font-weight: 400; color: #1e1e1e">
                      Category/Search Term
                    </div>
                    <select @change="changeCategory" v-model="dataType" style="margin-right: 10px; width: 96%"
                      class="form-control text-uppercase">
                      <option value="category">Category</option>
                      <option value="search">Search</option>
                    </select>
                  </div> -->
                  <!-- <b-button size="sm" @click="goToDetailPage" class="navigationButton">Show Details
              </b-button> -->
                </div>
              </div>
              <!-- <div class="borderBetween"></div> -->
              <!-- <div class="" style="display: flex; justify-content: space-between; align-items: center">
            <h4 class="graphHeading" style="margin-bottom: 0px !important">
              All Brands SOV Listing
            </h4>
            <b-button size="sm" @click="goToDetailPage" class="navigationButton">Show Details
            </b-button>
          </div> -->
              <div class="row">
                <div class="col-sm-12 mycol" ref="pieChartContainertopBrand">
                  <highcharts
                    style="width: 100%"
                    :options="pieChartAMD"
                    v-if="sosListingBrandDataShow"
                    ref="pieChartTopBrand"
                  >
                  </highcharts>
                  <div
                    v-else-if="!sosListingBrandDataShow && loader6"
                    class="onLoadingData mt-2"
                  >
                    {{ translatedLang["Loading"][selectedLanguage.key] }}...
                  </div>
                  <div
                    v-else
                    class="text-danger d-flex justify-content-center border border-danger rounded mt-1 p-2 noData"
                  >
                    {{
                      translatedLang["No Data Available"][selectedLanguage.key]
                    }}.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 pl-3">
            <div class="" id="category-data">
              <div
                class="space-between-header flex-wrap pb-0 mt-0 mb-0"
                style="align-items: center; margin: 11px 0"
              >
                <h3 class="graphHeading" style="margin-bottom: 0px !important">
                  <span class="text-dark">{{
                    translatedLang["All Brands"][selectedLanguage.key]
                  }}</span>
                </h3>
                <!-- <div class="d-flex">
                                    <b-button size="sm" @click="goToDetailPage" class="navigationButton">Show Details
                                    </b-button>
                                </div> -->
              </div>
              <!-- <div class="borderBetween"></div> -->
              <!-- <div class="" style="display: flex; justify-content: space-between; align-items: center">
            <h4 class="graphHeading" style="margin-bottom: 0px !important">
              All Brands SOV Listing
            </h4>
            <b-button size="sm" @click="goToDetailPage" class="navigationButton">Show Details
            </b-button>
          </div> -->
              <div class="row">
                <div class="col-sm-12 mycol" ref="pieChartContainer">
                  <highcharts
                    style="width: 100%"
                    :options="pieChartAMD2"
                    v-if="sosListingBrandDataShow"
                    ref="pieChart"
                  >
                  </highcharts>
                  <div
                    v-else-if="!sosListingBrandDataShow && loader6"
                    class="onLoadingData mt-2"
                  >
                    Loading...
                  </div>
                  <div
                    v-else
                    class="text-danger d-flex justify-content-center border border-danger rounded mt-1 p-2 noData"
                  >
                    No Data Available.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid card row ml-1" style="border-radius: 10px">
        <div class="col-sm-12 p-0">
          <div>
            <div class="d-flex overflow-auto">
              <div
                class="mx-3 font-bold tab-label"
                style="cursor: pointer"
                v-for="d in report"
                :key="d.key"
                @click="handleTabPanel(d.key)"
                :class="{ active: d.key === activeTab }"
              >
                {{ d.label }}
              </div>
            </div>
            <div class="borderBetweenTab"></div>
            <div v-for="d in report" :key="d.key">
              <div
                class="row pr-0 pr-lg-3"
                :class="{
                  'pl-lg-3': Object.keys(viewTableDataSummary).length == 0,
                }"
                v-if="d.key === activeTab"
              >
                <template
                  v-if="
                    viewSosTableDataShow &&
                    viewTableDataSummary[d.key].length !== 0
                  "
                >
                  <div
                    class="tabCalWidth pr-sm-0"
                    v-for="(row, i) in viewTableDataSummary[d.key].slice(0, 5)"
                    :key="i"
                    style="margin-bottom: 10px"
                  >
                    <div
                      class="h-100 w-100 position-relative"
                      style="
                        border: 1px solid rgba(217, 217, 217, 1);
                        border-radius: 8px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                      "
                    >
                      <div>
                        <div
                          class="py-1"
                          style="
                            display: flex;
                            justify-content: center;
                            box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
                              rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
                            height: 170px;
                            border-radius: 9px;
                            background: linear-gradient(
                              270deg,
                              rgba(0, 0, 0, 0.05) 0%,
                              rgba(255, 255, 255, 0) 100%
                            );
                          "
                        >
                          <img
                            v-if="row.image_url"
                            :src="row.image_url"
                            style="
                              height: 100% !important;
                              object-fit: cover;
                              mix-blend-mode: multiply;
                            "
                            class="img-fluid"
                          />
                          <img
                            v-else
                            src="../../../public/Icons_SVG/noProductImage.svg"
                            style="
                              height: 100% !important;
                              object-fit: cover;
                              mix-blend-mode: multiply;
                            "
                            class="img-fluid"
                          />
                        </div>
                        <a
                          :href="row.link"
                          target="_blank"
                          class="multiline-ellipsis"
                        >
                          <span
                            class="mt-2"
                            style="
                              display: block;
                              font-weight: 500;
                              padding: 10px 10px 0px 10px;
                              color: rgba(4, 99, 186, 1);
                            "
                            >{{ row.name }}</span
                          >
                        </a>
                      </div>
                      <div
                        class="d-flex justify-content-between mt-3 p-2"
                        style="font-weight: 500"
                      >
                        <span
                          ><span
                            style="color: rgba(6, 85, 89, 1); font-weight: 500"
                            >{{ row.ratings }}</span
                          ><span style="color: #949191">
                            / 5
                            <span
                              class="stars-outer"
                              style="position: relative; display: inline-block"
                            >
                              <span
                                class="stars-inner"
                                :style="starStyles(row)"
                              ></span>
                            </span>
                          </span>
                        </span>
                        <span
                          style="color: rgba(94, 94, 94, 1); font-weight: 500"
                        >
                          {{ row.reviews
                          }}<span class="px-1">
                            {{
                              translatedLang["Reviews"][selectedLanguage.key]
                            }}</span
                          >
                        </span>
                      </div>
                      <div class="reviewedRanking position-absolute">
                        #{{ i + 1 }}
                      </div>
                    </div>
                  </div>
                </template>
                <div
                  v-else-if="!viewSosTableDataShow && loaderTable"
                  class="onLoadingData w-100"
                >
                  Loading...
                </div>
                <div
                  class="mycol text-danger d-flex justify-content-center border border-danger rounded p-2 noData mt-0 ml-0 w-100"
                  style="font-family: Poppins"
                  v-else
                >
                  {{
                    `No ${d.key.replaceAll(
                      "_",
                      " "
                    )} is available for this category. Kindly select
                                    another category.`
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div
            class="col-sm-12 mycol text-danger d-flex justify-content-center border border-danger rounded p-2 noData mt-0"
            style="font-family: Poppins" v-else>
            No information is available for this category. Kindly select another category.
          </div> -->
      </div>
    </div>
    <!-- <b-modal body-class="" class="customModal" size="lg" title="Select Product" v-model="isProductModal">
      <div style="display: flex" class="searchInput">
        <input style="padding-left: 30px; border-radius: 0" class="form-control" v-model="schProduct" type="text"
          placeholder="Search Product" />
        <div class="searchIcon">
          <img src="/img/Search.4045f20d.svg" />
        </div>
      </div>
      <b-row class="pt-2 mt-3">
        <div class="col-md-5">
          <div class="row">
            <div class="col-md-3">
              <p class="mt-1 inputBoxTitle">Brand</p>
            </div>
            <div class="col-md-9 customSelect">
              <select @change="getProduct" v-model="selectedFilterBrand" style="text-transform: uppercase"
                class="form-control">
                <option value="">All</option>
                <option v-for="d in filterBrand" :value="d">{{ d }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-7">
          <div class="row">
            <div class="col-md-3">
              <p class="mt-1 inputBoxTitle">Category</p>
            </div>
            <div class="col-md-7 customSelect">
              <select @change="getProduct" v-model="selectedFilterCategory" style="text-transform: uppercase"
                class="form-control fluid">
                <option value="">All</option>
                <option v-for="d in itemCategory" :value="d.key">
                  {{ d.value }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </b-row>
      <div style="
          background: white;
          margin-top: 20px;
          cursor: pointer;
          height: 300px;
          overflow-y: scroll;
        ">
        <div class="eachProduct productListCheckbox" @click="selectProductNow('all')"
          style="padding: 4px; border-bottom: 1px solid #e6e6e6">
          All
        </div>
        <div :class="{ selectedProduct: selectedProduct == d }"
          v-if="d.toLowerCase().indexOf(schProduct.toLowerCase()) != -1" class="eachProduct productListCheckbox"
          @click="selectProductNow(d)" v-for="d in productOptions"
          style="padding: 4px; border-bottom: 1px solid var(--base_color-10)">
          <span>{{ d.toUpperCase() }}</span>
        </div>
      </div>
    </b-modal> -->
  </div>
</template>
<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Loader from "../Components/Loader.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Multiselect from "vue-multiselect";
import { mapState, mapActions } from "vuex";
export default {
  name: "sovindia4page",
  components: { Datepicker, Multiselect, Loader, Treeselect },
  data: function () {
    return {
      resizeObservers: [],
      selectedPlatform: "",
      activeTab: null,
      starTotal: 5,
      ratings: {},

      date: {
        startDate: moment().subtract(1, "day").format("YYYY-MM-DD"),
        // startDate: "2022-03-01",
        pStartDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
        disabled: {
          pstart: {
            to: moment("2023-04-25", "YYYY-MM-DD").toDate(),
            // from: moment("2022-12-21", "YYYY-MM-DD").toDate(),
          },
          start: {
            to: moment("2023-01-17", "YYYY-MM-DD").toDate(),
            // from: moment("2022-11-22", "YYYY-MM-DD").toDate(),
          },
        },
      },
      websitesUrls: {},
      columns: [
        { label: "Brand", field: "brand", sortable: false },
        { label: "Sub Brand", field: "sub_brand", sortable: false },
        { label: "Form Factor", field: "form_factor", sortable: false },
        { label: "Page 1 System Count", field: "page_1_system_count" },
        { label: "Page Count (page 1)", field: "page_1_count" },
        { label: "Page 1 SOV", field: "page_1_sov" },

        { label: "Pages 1-4 System Count", field: "page_1_3_system_count" },
        { label: "Pages Count (1-4)", field: "page_1_3_count" },
        { label: "Pages 1-4 SOV", field: "page_1_3_sov" },

        { label: "All Pages System Count", field: "page_all_system_count" },
        { label: "All Pages Count", field: "page_all_count" },
        { label: "All Pages SOV", field: "page_all_sov" },
      ],
      rows: [],
      sos_rows: [],
      rows_details: [],
      page: 1,
      charts: {},
      charts_sos: {},

      positionSOVTrendLineActive: false,
      // sovListingBrandActive: false,
      labelMapper: {
        brand: "Brand",
        processor_type: "Processor",
        // 'gpu_type': 'GPU'
      },
      isProductModal: false,

      countAMD: {},
      pieChartAMD: {},
      pieChartAMD2: {},
      barGraph: {},
      activePie: false,
      activeBarChart: false,
      selectedPage: "1-4",
      selectedPageTrendline: "1-4",
      loader: false,

      loader1: false,
      loader2: false,
      loader3: false,
      loader4: false,
      loader5: false,
      loader6: true,
      loader7: true,
      loader8: true,
      loader9: true,
      loaderTable: true,
      loaderUpdated: false,
      sosInsightsLoader: true,
      pageDistributionData: {},
      sovSOSGraph: {},
      activesovSOSGraph: true,
      // searchGraph: {},
      // activeSearchGraph: true,
      daywiseChartAverage: {},
      daywiseAMDCount: {},
      colorShades: {
        red: [
          "#f56464",
          "#fb7878",
          "#fb9178",
          "#fbc778",
          "#f57264",
          "#f56485",
          "#f56492",
        ],
        blue: [
          "#7887fb",
          "#788dfb",
          "#78a6fb",
          "#78b2fb",
          "#78d0fb",
          "#78d6fb",
          "#78c4fb",
        ],
        green: [
          "#9af575",
          "#87d866",
          "#80f564",
          "#9bf564",
          "#64f591",
          "#64f570",
          "#71b755",
        ],
      },
      index: {
        red: 0,
        blue: 0,
        green: 0,
      },
      daywiseChart: {},
      dailyData: [],
      amdCPUFilter: "all",
      pieTotal: "",
      comChart: {},
      activeComChart: false,
      selectedProduct: "",
      productOptions: [],
      reviewStartDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
      reviewEndDate: moment().format("YYYY-MM-DD"),
      reviewGraph: {},
      creviewGraph: {},
      activeReviewGraph: false,
      ratingGraph: {},
      cratingGraph: {},
      activeRatingGraph: false,
      totalReviewCount: "",
      ratingAvg: "",
      reviewStarData: {},
      sentimentData: {},
      sentimentChart: {},
      showBrand: true,
      activeSentimentChart: false,
      sovInterval: "day",
      sovStartDate: moment("2023-01-24")
        .subtract(1, "week")
        .format("YYYY-MM-DD"),
      sovEndDate: moment("2023-01-25").format("YYYY-MM-DD"),
      revInterval: "month",
      selectedWebComplianceScore: "",
      brand_list: [],
      gpu_list: [],
      schProduct: "",
      itemCategory: [],
      filterCategory: [],
      filterBrand: [],
      selectedItemCategory: {},
      tempSelectedItemCategory: {},
      client: JSON.parse(localStorage.reviewUserData).data.client,
      customClient: JSON.parse(localStorage.reviewUserData).data.brand_name[0],
      sovSections: JSON.parse(localStorage.reviewUserData).data.sov_sections,
      selectedFilterCategory: "",
      selectedFilterBrand: "",
      dataType: "search",
      icChangeOccur: false,
      viewTableDataSummary: {},
      report: [
        { key: "most_reviewed", label: "Most Reviewed" },
        { key: "least_reviewed", label: "Least Reviewed" },
        { key: "top_reviewed", label: "Top Reviewed" },
        { key: "worst_reviewed", label: "Worst Reviewed" },
      ],

      storeAllBrands: [],
      getbrandLoader: false,
      storeSelectedBrandName: "",

      loader0: false,
      dateRange: {
        startDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: new Date(),
      minDate: new Date(moment().subtract(1, "month")),
      lastUpdated: `${moment().format("YYYY-MM-DD")} 11:00 AM`,
      viewPlatformAndCategoryData: {},
      selected_website_sos: "",
      searchGraph: {},
      // activeSearchGraph: true,
      searchSosDataShow: false,
      positionSosBarDataShow: false,
      sosInsightsDataShow: false,
      positionSOSTrendLineDataShow: false,
      sosListingBrandDataShow: false,
      viewSosTableDataShow: false,

      storeSOSInsights: [],
      storeSubCategory: {
        treeFormatedDataForSubCategory: {},
        selectedSubCategory: [],
        options: [],
        groups: {},
      },
      storeAllDataForStatus: {},
      loaderStatus: false,
      excelDownloadLoader: false,
      showNoDataImgForUser: false,
      featureId: JSON.parse(localStorage.reviewUserData).data.feature_id_map.Share_Of_Search,
    };
  },
  watch: {
    sovInterval: function () {
      this.getTrendline();
      // this.getDailyData();
    },
    selectedItemCategory: function () {
      this.getAllBrandsFromApi(false);
      this.categoryChange();
      if (Object.keys(this.storeAllDataForStatus).length) {
        this.$store.dispatch(
          "DemoStore/setUpdatedStatus",
          this.storeAllDataForStatus[this.selected_website_sos.platform_id][
            this.selectedItemCategory.key
          ]
        );
      } else {
        this.$store.dispatch("DemoStore/setUpdatedStatus", "");
      }
    },

    dateRange: {
      handler() {
        this.getAllStatusByApi();
      },
      deep: true,
      immediate: true,
    },
    // revInterval: function () {
    //   if (this.selectedProduct) this.getReviews();
    // },
  },
  
  mounted() {
    this.getLastUpdatedDates();

    if (this.report.length > 0) {
      this.activeTab = this.report[0].key;
    }
    this.$nextTick(() => {
      this.setupResizeObservers([
        { ref: "chartContainer", method: this.resizeChart },
        { ref: "pieChartContainertopBrand", method: this.resizeTopBrandChart },
        { ref: "columnChartContainer", method: this.resizeColumnChart },
        { ref: "pieChartContainer", method: this.resizePieChart },
        { ref: "lineChartContainer", method: this.resizeLineChart },
      ]);
    });
  },

  beforeDestroy() {
    this.disconnectResizeObservers();
  },
  methods: {
    ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "initializeTranslation",
    ]),
    setupResizeObservers(charts) {
      charts.forEach(({ ref, method }) => {
        const observer = new ResizeObserver(() => method());
        observer.observe(this.$refs[ref]);
        this.resizeObservers.push(observer);
      });
    },
    disconnectResizeObservers() {
      this.resizeObservers.forEach((observer) => observer.disconnect());
      this.resizeObservers = [];
    },
    resizeChart() {
      if (this.$refs.chart.chart) {
        this.$refs.chart.chart.reflow();
      }
    },
    resizeTopBrandChart() {
      if (this.$refs.pieChartTopBrand.chart) {
        this.$refs.pieChartTopBrand.chart.reflow();
      }
    },
    resizeColumnChart() {
      if (this.$refs.columnChart.chart) {
        this.$refs.columnChart.chart.reflow();
      }
    },
    resizePieChart() {
      if (this.$refs.pieChart.chart) {
        this.$refs.pieChart.chart.reflow();
      }
    },
    resizeLineChart() {
      if (this.$refs.lineChart.chart) {
        this.$refs.lineChart.chart.reflow();
      }
    },

    //corrected
    getLastUpdatedDates() {
      this.loaderUpdated = true;
      const url = `/api/v2/india_clients/last_update?client=${this.client}&feature_id=${this.featureId}`;
      this.$http
        .get(url)
        .then((response) => {
          // response.body.data.sos = {
          // 	start_date: "2025-02-21",
          // 	end_date: "2025-02-23",
          // 	latest_time: "",
          // 	noon: {
          // 		start_date: "2025-02-21",
          // 		end_date: "2025-02-23",
          // 		latest_time: ""
          // 	},
          // 	amazon_retail_uae: {
          // 		start_date: "2025-02-22",
          // 		end_date: "2025-02-23",
          // 		latest_time: ""
          // 	},
          // 	amazon_retail: {
          // 		start_date: "2025-02-21",
          // 		end_date: "2025-02-21",
          // 		latest_time: ""
          // 	}
          // }
          if (response.body.data.sos) {
            localStorage.sos_last_update = JSON.stringify(
              response.body.data.sos
            );
            this.dateRange.endDate = moment(
              response.body.data.sos.end_date
            ).format("YYYY-MM-DD");
            this.dateRange.startDate = moment(response.body.data.sos.end_date)
              .subtract(1, "week")
              .format("YYYY-MM-DD");
            this.showNoDataImgForUser = false;
            this.getBrandDetails();
            this.loaderUpdated = false;
          } else {
            this.loader6 = false;
            this.loader7 = false;
            this.loader8 = false;
            this.loader9 = false;
            this.loaderTable = false;
            this.loaderStatus = false;
            this.loaderUpdated = false;
            this.sosInsightsLoader = false;
            this.showNoDataImgForUser = true;
            // this.loader7 = false,
            // this.loader8 = true,
            // this.loader9 = true,
            // this.loaderTable = true,
          }
        })
        .catch((err) => {
          this.loaderUpdated = false;
          // this.getBrandDetails();
          console.log("err", err);
        })
        .finally(() => {
          this.loaderUpdated = false;
        });
    },

    setDateRangeLastUpdated() {
      let SOSLastUpdated;
      if (this.selectedPlatform && this.selectedPlatform.platform_id) {
        SOSLastUpdated = JSON.parse(localStorage.sos_last_update);
        // console.log("check thed sov data", SOSLastUpdated)
        this.dateRange.endDate = SOSLastUpdated[
          this.selectedPlatform.platform_id
        ]
          ? moment(
              SOSLastUpdated[this.selectedPlatform.platform_id].end_date
            ).format("YYYY-MM-DD")
          : moment(SOSLastUpdated.end_date).format("YYYY-MM-DD");
        this.dateRange.startDate = SOSLastUpdated[
          this.selectedPlatform.platform_id
        ]
          ? moment(SOSLastUpdated[this.selectedPlatform.platform_id].end_date)
              .subtract(1, "week")
              .format("YYYY-MM-DD")
          : moment(SOSLastUpdated.end_date)
              .subtract(1, "week")
              .format("YYYY-MM-DD");
        this.maxDate = SOSLastUpdated[this.selectedPlatform.platform_id]
          ? new Date(SOSLastUpdated[this.selectedPlatform.platform_id].end_date)
          : new Date(SOSLastUpdated.end_date);
        this.minDate = SOSLastUpdated[this.selectedPlatform.platform_id]
          ? new Date(
              SOSLastUpdated[this.selectedPlatform.platform_id].start_date
            )
          : new Date(SOSLastUpdated.start_date);
        // this.getBrandDetails();
      }

      this.selectedPlatform && this.selectedPlatform.platform_id
        ? (this.lastUpdated = `${
            SOSLastUpdated[this.selectedPlatform.platform_id]
              ? moment(
                  SOSLastUpdated[this.selectedPlatform.platform_id].end_date
                ).format("DD MMM, YYYY")
              : moment(SOSLastUpdated.end_date).format("DD MMM, YYYY")
          } 
        ${
          SOSLastUpdated[this.selectedPlatform.platform_id]
            ? SOSLastUpdated[this.selectedPlatform.platform_id].latest_time
              ? "at"
              : ""
            : SOSLastUpdated.latest_time
            ? "at"
            : ""
        } 
        ${
          SOSLastUpdated[this.selectedPlatform.platform_id]
            ? SOSLastUpdated[this.selectedPlatform.platform_id].latest_time
            : SOSLastUpdated.latest_time
        }`)
        : (this.lastUpdated = `${moment(SOSLastUpdated.end_date).format(
            "DD MMM, YYYY"
          )} 
        ${SOSLastUpdated.latest_time ? "at" : ""} 
        ${SOSLastUpdated.latest_time}`);
      this.$store.dispatch("DemoStore/setTimeStamp", this.lastUpdated);
    },

    getBrandDetails() {
      let self = this;
      self.loader0 = true;
      const url = "/api/v2/india_clients/product_platform_details";
      let payload = {
        client: this.customClient,
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };
      this.$http
        .post(url, payload)
        .then((response) => {
          if (
            Object.keys(response.data.data).length &&
            response.data.data.platform.length &&
            Object.keys(response.data.data.search).length
          ) {
            self.viewPlatformAndCategoryData = response.data.data;
            if (response.data.data.platform) {
              self.selected_website_sos = response.data.data.platform[0];
              for (let link of response.data.data.platform) {
                self.websitesUrls[link.platform_link] = link.platform_name;
              }
            }

            localStorage.selected_website_sos =
              self.selected_website_sos.platform_link;

            // if(flag){

            this.handlePlatformSelection();
            self.changeWebsiteCategorySet("firstRender");
            this.setDateRangeLastUpdated();
            this.getAllStatusByApi();
            // }
          } else {
            this.loader6 = false;
            this.loader7 = false;
            this.loader8 = false;
            this.loader9 = false;
            this.loaderTable = false;
            this.loaderStatus = false;
            this.loaderUpdated = false;
            this.sosInsightsLoader = false;
          }
          this.loader0 = false;
        })
        .catch((err) => {
          self.loader0 = false;
          console.log("err", err);
        })
        .finally(() => {
          self.loader0 = false;
        });
    },
    handlePlatformSelection() {
      this.selectedPlatform = this.viewPlatformAndCategoryData.platform.find(
        (website) =>
          website.platform_link === this.selected_website_sos.platform_link
      );

      this.setDateRangeLastUpdated();
    },

    changeWebsiteCategorySet(flag) {
      // console.log('changes new')
      if (
        Object.keys(this.storeAllDataForStatus).length &&
        this.storeAllDataForStatus[this.selected_website_sos.platform_id]
      ) {
        this.$store.dispatch(
          "DemoStore/setUpdatedStatus",
          this.storeAllDataForStatus[this.selected_website_sos.platform_id][
            this.selectedItemCategory.key
          ]
        );
      } else {
        this.$store.dispatch("DemoStore/setUpdatedStatus", "");
      }
      this.filterCategory = "";
      for (let d of this.viewPlatformAndCategoryData.platform) {
        if (this.selected_website_sos.platform_link == d.platform_link) {
          if (
            this.viewPlatformAndCategoryData &&
            this.viewPlatformAndCategoryData.search &&
            this.viewPlatformAndCategoryData.search[d.platform_id]
          ) {
            this.itemCategory =
              this.viewPlatformAndCategoryData.search[d.platform_id];
          } else {
            // console.error("No data found for:", d.platform_name);
            this.itemCategory = [];
          }
          if (this.itemCategory != undefined) {
            this.selectedItemCategory = this.itemCategory[0];
            // this.tempSelectedItemCategory = this.itemCategory[0];
            // this.filterCategory = [this.itemCategory[0]];
          }

          localStorage.itemCategory = JSON.stringify(this.itemCategory);
          localStorage.viewPlatformAndCategoryData = JSON.stringify(
            this.viewPlatformAndCategoryData
          );
          if (flag == "firstRender") {
            this.tempSelectedItemCategory = this.itemCategory[0];
            this.categoryChange();
          }
        }
      }
      if (flag == "firstRender") this.data();
    },
    changedWebsite() {
      // this.getLastUpdatedDates(false);
      this.handlePlatformSelection();
      this.changeWebsiteCategorySet("websiteChange");
    },

    transformSubCategoryDataTreeFormate(data) {
      let result = {};
      this.storeSubCategory.groups = {};

      for (const [category, attributes] of Object.entries(data)) {
        const children = [];

        for (const [attribute, values] of Object.entries(attributes)) {
          this.storeSubCategory.groups[attribute] = values;
          children.push({
            id: `${attribute}`,
            label: attribute,
            children: values.map((value) => ({
              id: `${value}`,
              label: value,
            })),
          });
        }

        result[category] = {
          id: category,
          label: category.replace("_", " "),
          children,
        };
      }

      if (Object.keys(result).length) {
        this.storeSubCategory.treeFormatedDataForSubCategory = result;
      }
      return result;
    },

    updateSelectedLabels(value) {
      return value.platform_name.replaceAll("_", " ");
    },

    categoryChange() {
      if (this.selectedItemCategory) {
        // let viewPlatformAndCategoryData = JSON.parse(localStorage.viewPlatformAndCategoryData)
        // let treeformatedData = this.transformSubCategoryDataTreeFormate(viewPlatformAndCategoryData.sub_category);
        let treeformatedData =
          this.viewPlatformAndCategoryData.new_sub_category;
        this.storeSubCategory.options = [];
        this.storeSubCategory.selectedSubCategory = [];
        if (treeformatedData[this.selectedItemCategory.key] !== undefined) {
          this.storeSubCategory.options.push(
            treeformatedData[this.selectedItemCategory.key]
          );
          this.storeSubCategory.selectedSubCategory = [];
        } else {
          this.storeSubCategory.options = [];
          this.storeSubCategory.selectedSubCategory = [];
        }
      }
    },

    getAllStatusByApi() {
      let self = this;
      self.loaderStatus = true;
        const url = "api/v2/sensespiderstatus";
        let payload = {
          timestamp: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
          feature: "search",
          feature_id: this.featureId,
        };
      self.$http
        .post(url, payload)
        .then((response) => {
          self.storeAllDataForStatus = response.body.data;
          if (Object.keys(self.storeAllDataForStatus).length) {
            self.$store.dispatch(
              "DemoStore/setUpdatedStatus",
              self.storeAllDataForStatus[self.selected_website_sos.platform_id][
                self.selectedItemCategory.key
              ]
            );
          } else {
            self.$store.dispatch("DemoStore/setUpdatedStatus", "");
          }
          self.loaderStatus = false;
        })
        .catch((err) => {
          console.log(err);
          self.loaderStatus = false;
        })
        .finally(() => {
          self.loaderStatus = false;
        });
    },

    data() {
      let self = this;
      if (this.itemCategory.length) {
        localStorage.demo_selectedItemCategory = JSON.stringify(
          this.selectedItemCategory
        );

        if (localStorage.demo_selectedItemCategory) {
          this.selectedItemCategory = {};
          for (let [i, k] of this.itemCategory.entries()) {
            if (
              k.key == JSON.parse(localStorage.demo_selectedItemCategory).key
            ) {
              this.selectedItemCategory = k;
            }
          }
          if (!Object.keys(this.selectedItemCategory).length) {
            this.selectedItemCategory = this.itemCategory[0];
          }
        } else self.selectedItemCategory = this.itemCategory[0];
      }

      this.clientMapper = {
        brand: this.client,
        "non-brand": "Non-" + this.client,
      };
      this.reviewStartDate = moment()
        .subtract(1, "year")
        .startOf("year")
        .format("YYYY-MM-DD");
      this.reviewEndDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
      this.sovStartDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
      this.sovEndDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
      this.getAllBrandsFromApi(true);

      // this.getDailyData();
      /*
       */
      this.refresh();
    },
    getSectionWiseData() {
      this.sos();
      this.getPageDistribution();
      this.getTrendline();
      this.getPie();
      this.getReport();
      this.getAllSOSInsights();
      // this.getProduct();
      // this.getFilterBrand();
      // if (this.sovSections.sov_bar_charts) {
      //   this.sos();
      //   this.getPageDistribution();
      // }

      // if (this.sovSections.sov_trendline) {
      //   this.getTrendline();
      // }

      // if (this.sovSections.reviews_section) {
      //   this.getProduct();
      //   this.getFilterBrand();
      // }

      // if (this.sovSections.category_data) {
      //   this.getPie();
      // }

      // if (this.sovSections.report_table) {
      //   this.getReport();
      // }
    },
    refresh0() {
      self = this;
      if (!self.icChangeOccur) {
        if (this.itemCategory.length) {
          this.selectedItemCategory = this.itemCategory[0];
          localStorage.demo_selectedItemCategory = JSON.stringify(
            this.selectedItemCategory
          );
        } else {
          this.selectedItemCategory = {};
        }
        // this.selectedFilterCategory = this.itemCategory[0].key;
      }
      self.icChangeOccur = false;
      this.getSectionWiseData();
      this.refresh();
    },
    icChanged() {
      this.icChangeOccur = true;
      // if (this.selectedItemCategory.key == "womens kurtas") {
      //   this.selectedFilterCategory = "womens kurtas";
      // } else {
      //   this.selectedFilterCategory = this.selectedItemCategory.key;
      // }
      if (this.selectedItemCategory.key) {
        localStorage.demo_selectedItemCategory = JSON.stringify(
          this.selectedItemCategory
        );
      }
      this.refresh0();
    },
    filterApply() {
      this.tempSelectedItemCategory = this.selectedItemCategory;
      this.icChanged();
      this.selectedItemCategory = this.tempSelectedItemCategory;
    },

    // changeCategory() {
    //   // if (this.sovSections.category_data) {
    //   this.getPie();
    //   // }
    //   // if (this.sovSections.report_table) {
    //   this.getReport();
    //   // }
    // },

    // changeSOVandTrendDate() {
    //   this.getTrendline();
    //   this.getDailyData();
    // },

    // selectProductNow(d) {
    //   let self = this;
    //   self.selectedProduct = d;
    //   self.refreshReview();
    //   self.isProductModal = false;
    // },

    // showProductModal() {
    //   let self = this;
    //   self.isProductModal = true;
    // },

    // goToCompliance() {
    //   let self = this;
    //   localStorage.selectedWebComplianceScore = self.selectedWebComplianceScore;
    //   window.location = "#/compliance-detail";
    // },

    // formatDate(key, d) {
    //   let self = this;
    //   let obj = {
    //     day: moment(d).format("MMM DD, YY"),
    //     month: moment(d).format("MMM YY"),
    //     week: "",
    //   };
    //   if (self[key] == "week") {
    //     let end_date = moment(d).add(6, "days");
    //     let today = moment(self.dateRange.endDate).format("YYYY-MM-DD");
    //     if (end_date >= today) end_date = today;
    //     obj["week"] =
    //       moment(d).format("MMM DD, YY") +
    //       " - " +
    //       moment(end_date).format("MMM DD, YY");
    //   }
    //   return obj[this[key]];
    // },
    getReport() {
      let self = this;
      self.viewTableDataSummary = {};
      self.loaderTable = true;
      let payload = {
        client: self.customClient,
        item_category: self.selectedItemCategory.key,
        website: self.selected_website_sos.platform_link,
        data_type: self.dataType,
        timestamp: moment(self.dateRange.endDate).format("YYYY-MM-DD"),
        sub_category: self.storeSubCategory.selectedSubCategory,
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };
      const url = "/api/v2/india_clients/reviews_table_data";
      this.$http
        .post(url, payload)
        .then((response) => {
          this.viewSosTableDataShow = response.data.data_present;
          self.viewTableDataSummary = response.data.data;
          self.loaderTable = false;
        })
        .catch((err) => {
          console.log(err);
          self.loaderTable = false;
          this.viewSosTableDataShow = false;
        })
        .finally(() => {
          self.loaderTable = false;
        });
    },
    // drawReviewGraph(reviewData) {
    //   let self = this;
    //   self.totalReviewCount = reviewData.count;
    //   let revRat = [
    //     {
    //       label: "Review",
    //       key: "review_count",
    //       graph: "reviewGraph",
    //       active: "activeReviewGraph",
    //     },
    //     {
    //       label: "Rating",
    //       key: "rating",
    //       graph: "ratingGraph",
    //       active: "activeRatingGraph",
    //     },
    //     {
    //       label: "Cummulative Review",
    //       key: "commulative_review_count",
    //       graph: "creviewGraph",
    //       active: "activeReviewGraph",
    //     },
    //     {
    //       label: "Cummulative Rating",
    //       key: "commulative_rating",
    //       graph: "cratingGraph",
    //       active: "activeReviewGraph",
    //     },
    //     // { label:'Rating', key:'rating', graph: 'ratingGraph', active: 'activeRatingGraph' }
    //   ];
    //   let sumRating = 0;
    //   for (let [idx, dataset] of reviewData.timeline.entries()) {
    //     sumRating += dataset.rating;
    //   }
    //   self.ratingAvg = sumRating / reviewData.timeline.length;
    //   self.ratingAvg = Math.round(self.ratingAvg);
    //   let y_labels = [
    //     "Review Count",
    //     "Avg. Rating",
    //     "Cummulative Review Count",
    //     "Cummulative Rating",
    //   ];
    //   let tick_arr = [50, 1];
    //   let max_arr = [undefined, 5];
    //   for (let [ii, rr] of revRat.entries()) {
    //     let cat = [];
    //     let data = [];
    //     for (let [idx, dataset] of reviewData.timeline.entries()) {
    //       cat.push(self.formatDate("revInterval", dataset.date));
    //       data.push(dataset[rr.key]);
    //     }
    //     self[rr.graph] = {
    //       chart: {
    //         type: "line",
    //         height: 180,
    //         marginBottom: 50,
    //         marginTop: 20,
    //       },
    //       title: {
    //         text: "",
    //       },
    //       exporting: {
    //         enabled: false,
    //       },
    //       subtitle: {
    //         text: "",
    //       },
    //       xAxis: {
    //         categories: cat,
    //         title: {
    //           text: null,
    //         },
    //       },
    //       yAxis: {
    //         min: 0,
    //         tickInterval: tick_arr[ii],
    //         max: max_arr[ii],
    //         title: {
    //           text: y_labels[ii],
    //           margin: 25,
    //           style: {
    //             color: "#065559",
    //           },
    //         },
    //       },
    //       tooltip: {
    //         formatter: function () {
    //           var mytooltip = this.key + "<br/>";

    //           mytooltip +=
    //             '<span style="color:' + this.series.color + '">\u25CF</span> ';
    //           mytooltip += this.series.name;
    //           mytooltip += " : <b> " + self.format(this.y);

    //           mytooltip += "</b><br/>";

    //           return mytooltip;
    //         },
    //         borderWidth: 0,
    //         shadow: {
    //           color: "#d6d6d6",
    //           opacity: 0.1,
    //           width: 10,
    //         },
    //         borderRadius: 6,
    //         backgroundColor: "#ffffff",
    //       },

    //       legend: {
    //         enabled: false,
    //       },
    //       credits: {
    //         enabled: false,
    //       },
    //       series: [
    //         {
    //           name: rr.label,
    //           data: data,
    //           color: "#47A694",
    //           marker: {
    //             states: {
    //               hover: {
    //                 radiusPlus: 5,
    //                 lineWidthPlus: 3,
    //               },
    //             },
    //           },
    //         },
    //       ],
    //     };
    //     if (rr.graph == "ratingGraph") self["ratingGraph"]["yAxis"]["min"] = 0;
    //     setTimeout(function () {
    //       self[rr.active] = true;
    //     }, 200);
    //   }
    // },

    // getReviews() {
    //   let self = this;
    //   self.loader2 = true;
    //   self.activeReviewGraph = false;
    //   let payload = {
    //     start_date: moment(self.reviewStartDate).format("YYYY-MM-DD"),
    //     end_date: moment(self.reviewEndDate).format("YYYY-MM-DD"),
    //     interval: self.revInterval,
    //     client: self.customClient,
    //     // "item_category": self.selectedItemCategory.key
    //   };
    //   if (self.selected_website_sos.platform_link != "all") {
    //     payload["channel"] = self.websitesUrls[self.selected_website_sos.platform_link];
    //   }
    //   if (self.selectedProduct != "all") {
    //     payload["product_name"] = self.selectedProduct;
    //   }

    //   const url = "/api/v2/india_clients/multi/review/hist";
    //   self.$http.post(url, payload).then(
    //     (response) => {
    //       self.loader2 = false;
    //       self.drawReviewGraph(response.body.data);
    //     },
    //     (err) => {
    //       self.loader2 = false;
    //       console.log("err");
    //     }
    //   );
    // },

    // refreshReview() {
    //   let self = this;
    //   if (self.selectedProduct) self.getReviews();
    // },

    goToDetailPage() {
      window.location = "#/sos-detailed/" + this.customClient;
    },
    // goToReview() {
    //   window.location = "#/reviewslist/" + this.customClient;
    // },

    format(v) {
      return this.$options.filters.format(v);
    },

    refresh() {
      var self = this;

      self.loader3 = true;
      const url = "/api/v2/india_clients/product_set_list";
      let payload = {
        client: this.customClient,
        // language: this.$store.state.DemoStore.selectedLanguage.key,
      };
      this.$http
        .post(url, payload)
        .then((response) => {
          this.loader3 = false;
          let resData = response.body.data;
          localStorage.demo_voc_product_list = JSON.stringify(
            resData.voc_product_list
          );
        })
        .catch((err) => {
          self.loader3 = false;
          console.log("err", err);
        })
        .finally(() => {
          self.loader3 = false;
        });
    },
    // getFilterBrand() {
    //     let self = this;
    //     self.loader4 = true;
    //     const url = "/api/v2/india_clinets/get_brand_list_india_client";
    //     let payload = {
    //         channel: self.websitesUrls[self.selected_website],
    //         client: self.customClient,
    //     };
    //     this.$http.post(url, payload).then(
    //         (response) => {
    //             self.loader4 = false;
    //             self.filterBrand = response.data.data;
    //         },
    //         (err) => {
    //             self.loader4 = false;
    //         }
    //     );
    // },
    // getProduct() {
    //     var self = this;
    //     self.loader5 = true;
    //     const url = "/api/v2/india_clients/multi/products_list";
    //     let payload = {
    //         channel: self.websitesUrls[self.selected_website],
    //         item_category: self.selectedFilterCategory,
    //         brand: self.selectedFilterBrand,
    //         client: self.customClient,
    //     };
    //     this.$http.post(url, payload).then(
    //         (response) => {
    //             self.loader5 = false;
    //             let resData = response.body.data;
    //             self.productOptions = resData;
    //             self.selectedProduct = self.productOptions[0];
    //             self.refreshReview();
    //         },
    //         (err) => {
    //             self.loader5 = false;
    //             console.log(err);
    //             console.log("err");
    //         }
    //     );
    // },

    // sov count report download
    sosCountReportApi() {
      let self = this;
      self.excelDownloadLoader = true;
      let payload = {
        platform_name: self.selectedPlatform.platform_id,
        start_date: moment(self.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(self.dateRange.endDate).format("YYYY-MM-DD"),
        item_category: self.tempSelectedItemCategory.key,
        feature: "search",
        sub_category: self.storeSubCategory.selectedSubCategory,
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };
      const url = "/api/v1/india_clients/sov_count_report";
      this.$http
        .post(url, payload)
        .then((response) => {
          self.excelDownloadLoader = false;
          window.location = response.body.data;
        })
        .catch((err) => {
          console.log(err);
          self.excelDownloadLoader = false;
        });
    },

    // sos insights
    getAllSOSInsights() {
      let self = this;
      self.sosInsightsLoader = true;
      self.sosInsightsDataShow = false;
      let payload = {
        platform_name: self.selectedPlatform.platform_id,
        start_date: moment(self.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(self.dateRange.endDate).format("YYYY-MM-DD"),
        item_category: self.selectedItemCategory.key,
        brand_name: self.storeSelectedBrandName.key,
        feature: "search",
        sub_category: self.storeSubCategory.selectedSubCategory,
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };
      const url = "/api/v2/indian_clients/sov_insights";
      this.$http
        .post(url, payload)
        .then((response) => {
          // console.log(response)
          this.storeSOSInsights = response.body.data;
          self.sosInsightsDataShow = response.body.data_present;
          self.sosInsightsLoader = false;
        })
        .catch((err) => {
          console.log(err);
          self.sosInsightsLoader = false;
        });
    },

    //corrected : SOV Listing top 5 pie
    createPie(allData) {
      let brands = allData.top5_percent
      let self = this;
      let color_codes = [
        // "#47A694",
        // "#54736D",
        // "#265950",
        // "#79A69E",
        // "#317367",
        // "#54736D",
        // "#52BFAB",
        // "#84B5AC",
        // "#5F827C",
        // "#388273",
        // "#59CFB7"

        // "#98E8D7",
        // "#065559",
        // "#BCF0E4",
        // "#E0F7F2",
        // "#50ABA0",
        // "#81C1B8",
        // "#AAD5D0",
        // "#44777A",
        // "#75A49E",
        // "#A4C3BE",
        // "#46877D",

        // "#B5DBD4",
        // "#CCDCDD",
        // "#E6EDEE",
        // "#F1F5F5",
        // "#DAEDE9",
        // "#9ABABC",
        // "#6A999B",
        // "#6AB7A8",
        // "#90C8BE",
        // "#6A999B80"

        // popular colors
        // "#B5DBD4",
        // "#90C8BE",
        // "#6AB7A8",
        // "#F1F5F5",
        // "#DAEDE9",
        // "#CCDCDD",

        // new colors
        "#EBBB69",
        "#99B9FF",
        "#BACDF8",
        "#92CED6",
        "#F6C69E",
        "#ABE6E9",
        "#FF9C9C",
        "#ECF3FD",
        "#FFB9CF",
        "#B7DCBD",
        "#F9E6A4",
        "#FFB06F",
        "#FF9C9C",
        "#EDB6AF",
        "#FF9EEF",

        // "#07beb8",
        // "#3dccc7",
        // "#68d8d6",
        // "#9ceaef"

        // "#ebefbf",
        // "#ddc7f8",
        // "#ff8392",
        // "#ffa2a4",
        // "#ffd0b1",
        // "#d7edbb",
        // "#9ddec5",
        // "#899efc",
        // "#eaa9fb",
        // "#ffd7d8",
        // "#dbd0bf",
      ];
      let color_index = 0;
      let total = 0;
      let seriesData = [];
      for (let [i, d] of Object.entries(allData.top5)) total += d;
      for (let [i, d] of Object.entries(brands)) {
        let obj = {
          name: i,
          y: d,
          total: total,
          // color: i === self.customClient ? "#FCB117" : color_codes[color_index]
          color:
            this.translateBrandNameinEn(i) === self.customClient
              ? "#FCB117"
              : this.translateBrandNameinEn(i) ==
                  self.storeSelectedBrandName.key &&
                self.storeSelectedBrandName.key !== self.customClient
              ? "#f0629366"
              : color_codes[color_index],
        };
        if (color_index == color_codes.length - 1) color_index = 0;
        else color_index++;
        seriesData.push(obj);
      }
      self.pieChartAMD = {
        chart: {
          marginTop: 60,
          marginBottom: 60,
          height: 500,
        },
        title: {
          // text:
          //   self.selectedItemCategory.value +
          //   "  Brand Category Page (" +
          //   self.selectedPage +
          //   ") Distribution by All Brands <br> Total Results: " +
          //   total,
          // text: " Total Results: " + total,
          text: `${
            this.translatedLang["Total Results"][this.selectedLanguage.key]
          }: ${total}`,
          verticalAlign: "bottom",
          style: {
            fontSize: "14px",
            fontFamily: "Poppins",
            fontWeight: "600",
            color: "#01695C",
            letterSpacing: "1px",
          },
        },
        credits: {
          enabled: false,
        },
        exporting: {
          enabled: false,
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        tooltip: {
          formatter() {
            var mytooltip = "";
            // mytooltip +=
            //   '<span style="font-size:22px;color:' +
            //   this.point.color +
            //   '">\u25CF</span> ';
            mytooltip +=
              '<span style="color:white; font-weight:700; font-size:16px; text-transform:capitalize;">';
            mytooltip += this.point.name + "<br/>";
            mytooltip += "</span>";
            mytooltip +=
              '<span style="color:white; font-weight:700; font-size:16px;">';
            mytooltip += self.format(allData?.top5[this.point.name])+" ("+ self.format(this.point.y) + "%)";
             
            mytooltip += "</span>";
            // mytooltip += "Total: <b>" + self.format(this.point.total) + "</b>";
            return mytooltip;
          },
          shared: true,
          outside: true,
          useHTML: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 10,
          backgroundColor: "#065559",
          padding: 12,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            // shadow: true
          },
          pie: {
            dataLabels: {
              enabled: true,
              useHTML: true,
              formatter: function () {
                self.pieTotal = this.point.total;

                return (
                  '<span style="color:black;font-size:16px;font-weight:normal">' +
                 this.point.y +
                  "%</span>"
                );
              },
              distance: -30,
              style: {
                fontSize: "9px",
                fontFamily: "Poppins",
                fontWeight: "400",
              },
            },
            showInLegend: true,
            size: "90%",
            // size: "100%"
          },
          // pie: {
          //   allowPointSelect: true,
          //   borderWidth: 2,
          //   cursor: 'pointer',
          //   dataLabels: {
          //     enabled: true,
          //     format: '<b>{point.name}</b><br>{point.percentage}%',
          //     distance: 20
          //   }
          // }
        },
        legend: {
          layout: "vertical",
          alignColumns: true,
          align: "right",
          y: 0,
          x: 0,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 35,
          margin: 0,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 10,
          itemMarginTop: 4,
          itemMarginBottom: 4,
          itemStyle: {
            // color: "#a1a1a1",
            fontSize: "14px",
            fontWeight: 600,
            fontFamily: "Poppins",
            textTransform: "capitalize",
            letterSpacing: "1px",
          },
          itemHoverStyle: {
            color: "#065559",
          },
          labelFormatter: function () {
            let dynamicColor =
              self.translateBrandNameinEn(this.name) === self.customClient
                ? "#FCB117"
                : self.translateBrandNameinEn(this.name) ==
                    self.storeSelectedBrandName.key &&
                  self.storeSelectedBrandName.key !== self.customClient
                ? "#f0629366"
                : "#a1a1a1";

            return `<span style="color:${dynamicColor}" class='highChartlegendColorHover'>${this.name}</span>`;
          },
          useHTML: true,
        },
        series: [
          {
            type: "pie",
            innerSize: "50%",
            data: seriesData,
          },
        ],
      };
      // setTimeout(function () {
      // 	self.activePie = true;
      // }, 50);
      // self.sovListingBrandActive = true;
    },

    createPieForALLBrands(allData) {
      let brands = allData.all_brand_percent
      let self = this;
      let color_codes = [
        // popular colors
        // "#B5DBD4",
        // "#90C8BE",
        // "#6AB7A8",
        // "#F1F5F5",
        // "#DAEDE9",
        // "#CCDCDD",

        // new colors
        "#EBBB69",
        "#99B9FF",
        "#BACDF8",
        "#92CED6",
        "#F6C69E",
        "#ABE6E9",
        "#FF9C9C",
        "#ECF3FD",
        "#FFB9CF",
        "#B7DCBD",
        "#F9E6A4",
        "#FFB06F",
        "#FF9C9C",
        "#EDB6AF",
        "#FF9EEF",
      ];
      let color_index = 0;
      let total = 0;
      let seriesData = [];
      for (let [i, d] of Object.entries(allData.all_brand)) total += d;
      for (let [i, d] of Object.entries(brands)) {
        let obj = {
          name: i,
          y: d,
          total: total,
          // color: i === self.customClient ? "#FCB117" : color_codes[color_index],
          color:
            this.translateBrandNameinEn(i) === self.customClient
              ? "#FCB117"
              : this.translateBrandNameinEn(i) ==
                  self.storeSelectedBrandName.key &&
                self.storeSelectedBrandName.key !== self.customClient
              ? "#f0629366"
              : color_codes[color_index],
        };
        if (color_index == color_codes.length - 1) color_index = 0;
        else color_index++;
        seriesData.push(obj);
      }
      self.pieChartAMD2 = {
        chart: {
          marginTop: 30,
          marginBottom: 60,
          height: 500,
        },
        title: {
          text: "",
          // verticalAlign: "bottom",
          // style: { fontSize: 15, fontWeight: "600", color: "#01695C" },
          text: `${
            this.translatedLang["Total Results"][this.selectedLanguage.key]
          }: ${total}`,
          // text: " Total Results: " + total,
          verticalAlign: "bottom",
          style: {
            fontSize: "14px",
            fontFamily: "Poppins",
            fontWeight: "600",
            color: "#01695C",
            letterSpacing: "1px",
          },
        },
        credits: {
          enabled: false,
        },
        exporting: {
          enabled: false,
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        tooltip: {
          formatter() {
            var mytooltip = "";
            mytooltip +=
              '<span style="color:white; font-weight:700; background-color:#065559; font-size:16px; text-transform:capitalize;">';
            mytooltip += this.point.name + "<br/>";
            mytooltip += "</span>";
            mytooltip += 
              '<span style="color:white; font-weight:700; font-size:16px;">';
            mytooltip += self.format(allData?.all_brand[this.point.name])+" ("+ self.format(this.point.y) + 
              "%)";
            mytooltip += "</span>";
            return mytooltip;
          },
          shared: true,
          outside: true,
          useHTML: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0,
            width: 10,
          },
          borderRadius: 10,
          backgroundColor: "#065559",
          padding: 12,
          fontFamily: "Poppins",
          opacity: 0,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            // shadow: true
          },
          pie: {
            size: "80%",
            allowPointSelect: true,
            borderWidth: 2,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              useHTML: true,
              // formatter: function(){
              //   '<span style="color:black;font-size:16px;font-weight:normal">'  +
              //     self.format(this.point.percentage.toFixed()) +
              //     "%</span>"
              // },
              formatter: function () {
                // console.log(this.point.name)
                const capitalizedName = this.point.name
                  .split(" ")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1));

                let dynamicColorPick = `${
                  self.translateBrandNameinEn(this.point.name) ===
                  self.customClient
                    ? "#FCB117"
                    : self.translateBrandNameinEn(this.point.name) ==
                        self.storeSelectedBrandName.key &&
                      self.storeSelectedBrandName.key !== self.customClient
                    ? "#f0629366"
                    : "#a1a1a1"
                }`;

                return `<span style="color:${dynamicColorPick}; font-size:13px; font-family:Poppins; font-weight:400; text-transform: capitalize;"><b>${this.point.name}</b><br>${this.point.y}%</span>`;
              },
              distance: 32,
              connectorColor: "silver",
              connectorWidth: 1.5,
              zIndex: 0,
            },
          },
        },
        legend: {
          layout: "vertical",
          alignColumns: true,
          align: "right",
          y: 0,
          x: 0,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 35,
          margin: 0,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 10,
          itemMarginTop: 4,
          itemMarginBottom: 4,
          itemStyle: {
            color: "#a1a1a1",
            fontSize: "14px",
            fontWeight: 600,
            fontFamily: "Poppins",
            textTransform: "capitalize",
            letterSpacing: "1px",
          },
          itemHoverStyle: {
            color: "#065559", // Hover color
          },
        },
        series: [
          {
            type: "pie",
            innerSize: "0",
            data: seriesData,
          },
        ],
      };
      // setTimeout(function () {
      // 	self.activePie = true;
      // }, 50);
      // self.sovListingBrandActive = true;
    },
    // corrected done
    getPie() {
      let self = this;
      self.loader6 = true;
      this.sosListingBrandDataShow = false;
      // const url = "/api/v2/india_clients/product_brand_wheel";
      const url = "/api/v3/india_clients/product_brand_wheel";
      let payload = {
        website: self.selected_website_sos.platform_link,
        start_date: moment(self.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(self.dateRange.endDate).format("YYYY-MM-DD"),
        item_category: self.tempSelectedItemCategory.key,
        client: self.customClient,
        data_type: self.dataType,
        page: self.selectedPage,
        brand_name: self.storeSelectedBrandName
          ? self.storeSelectedBrandName.key
          : [],
        translated_brand_name: self.storeSelectedBrandName.value,
        feature: "search",
        sub_category: self.storeSubCategory.selectedSubCategory,
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };
      this.$http
        .post(url, payload)
        .then((response) => {
          self.loader6 = false;
          let resData = response.body.data;
          let resDataForAllBrands = response.body.data;
          this.sosListingBrandDataShow = response.body.data_present;
          self.createPie(resData);
          self.createPieForALLBrands(resDataForAllBrands);
        })
        .catch((err) => {
          self.loader6 = false;
          this.sosListingBrandDataShow = false;
          console.log(err, "err");
        })
        .finally(() => {
          self.loader6 = false;
        });
    },

    // corrected done
    drawDailyChart(d) {
      // console.log('ddddddddddddd', d)
      let self = this;
      let categories = [];
      let data3 = [];
      // let data4 = [];
      let totalCount = "";
      let obj = {};

      if (!d || d.length === 0) {
        self.daywiseChart = {
          chart: { type: "line", height: 380, marginTop: 50, marginBottom: categories.length>11?65:40 },
          title: { text: "No Data Available" },
          xAxis: { categories: [] },
          yAxis: { min: 0, max: 100, tickInterval: 25 },
          series: [
            // { name: self.selectedItemCategory.value + " " + "Category", data: [] },
            {
              name: self.selectedItemCategory.value + " " + "",
              data: [],
            },
          ],
        };
        return;
      }
      for (let [idx, dataset] of d.entries()) {
        // categories.push(self.formatDate("sovInterval", dataset.timestamp));
        categories.push(moment(dataset.timestamp).format("D MMM"));
        let bsov = Math.round(dataset.share_percentage);
        // let nbsov = Math.round(dataset.non_brand_sov);
        totalCount = dataset.total_count;
        data3.push(bsov);
        // data4.push(nbsov);
      }
      self.daywiseChart = {
        chart: { type: "line", height: 380, marginTop: 50, marginBottom: categories.length>11?65:40 },
        title: { text: "" },
        exporting: {
          enabled: false,
        },
        subtitle: {
          text: "",
          verticalAlign: "top",
          align: "left",
          x: 0,
          y: 0,
        },
        xAxis: {
          categories: categories,
          crosshair: {
            width: 70,
          },
          labels: {
            y: 32,
            style: {
              color: "#a1a1a1",
              fontFamily: "Heebo",
              fontWeight: 400,
              fontSize: "14px",
              // letterSpacing: '1px',
            },
          },
          title: { text: "" },
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
              style: { fontWeight: 0 },
              formatter: function () {
                let category = this.point.category;
                let plotY = this.point.plotY;
                if (obj.hasOwnProperty(category)) obj[category].push(plotY);
                else {
                  obj[category] = [];
                  obj[category].push(plotY);
                }
                let plotYPos = obj[category].indexOf(plotY);
                let prvPlotY = obj[category][plotYPos - 1];
                if (plotYPos > 0) {
                  if (plotY - prvPlotY < 9 && plotY - prvPlotY > -9) {
                    this.point.plotY = this.point.plotY + 9;
                    obj[category][plotYPos] = this.point.plotY;
                  }
                }
                return this.point.y + "%";
              },
            },
          },
        },
        yAxis: {
          title: { text: "" },
          min: 0,
          max: 100,
          tickInterval: 25,
          gridLineDashStyle: "longdash",
          lineColor: "rgba(228, 237, 238, 1)",
          lineWidth: 2,
          labels: {
            x: -23,
            style: {
              color: "#a1a1a1",
              fontFamily: "Heebo",
              fontWeight: 400,
              fontSize: "14px",
              // letterSpacing: '1px',
            },
          },
        },
        tooltip: {
          formatter: function () {
            var mytooltip = "";
            for (var i = 0; i < this.points.length; i++) {
              mytooltip +=
                '<span style="color:' +
                this.points[i].series.color +
                '">\u25CF</span> ';
              mytooltip += "&nbsp;&nbsp;" + self.format(this.points[i].y) + "%";
              mytooltip += "<br/>";
            }
            return mytooltip;
          },
          useHTML: true,
          shared: true,
          padding: 10,
          borderWidth: 1,
          borderColor: "rgba(212, 212, 212, 1)",
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          style: {
            fontSize: "16px",
          },
          borderRadius: 15,
          backgroundColor: "#ffffff",
        },
        legend: {
          layout: "vertical",
          floating: true,
          align: "right",
          y: -10,
          x: 0,
          verticalAlign: "top",
          itemStyle: {
            fontFamily: "Poppins",
            fontWeight: 600,
            color: "#a1a1a1",
            fontSize: "14px",
            letterSpacing: "1px",
            textTransform: "capitalize",
          },
          itemMarginTop: 0,
          itemMarginBottom: 0,
        },
        credits: { enabled: false },
        series: [
          // {
          //     name: self.selectedItemCategory.value + " " + "Category",
          //     data: data3,
          //     color: "#46A493",
          //     tooltip: { valueSuffix: " %" },
          //     marker: {
          //         enabled: true,
          //         lineWidth: 2,
          //         fillColor: "white",
          //         lineColor: "#46A493",
          //         radius: 5,
          //     },
          // },
          {
            name: self.tempSelectedItemCategory.value + " " + "",
            data: data3,
            color: "#46A493",
            tooltip: { valueSuffix: " %" },
            marker: {
              enabled: true,
              lineWidth: 2,
              fillColor: "white",
              // lineColor: "#FCB117",
              lineColor: "#46A493",
              radius: 5,
            },
          },
        ],
      };
      self.positionSOVTrendLineActive = true;
    },

    //corrected for position sov trendLine done
    getTrendline() {
      var self = this;
      self.loader7 = true;
      this.positionSOSTrendLineDataShow = false;
      const url = "/api/v3/india_clients/product_sov_trendline";
      let payload = {
        website: self.selected_website_sos.platform_link,
        start_date: moment(self.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(self.dateRange.endDate).format("YYYY-MM-DD"),
        // start_date: moment(self.sovStartDate).format("YYYY-MM-DD"),
        // end_date: moment(self.sovEndDate).format("YYYY-MM-DD"),
        item_category: self.tempSelectedItemCategory.key,
        // client: self.customClient,
        interval: self.sovInterval,
        page: self.selectedPageTrendline,
        feature: "search",
        sub_category: self.storeSubCategory.selectedSubCategory,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        brand_name: self.storeSelectedBrandName
          ? self.storeSelectedBrandName.key
          : [],
      };
      this.$http
        .post(url, payload)
        .then((response) => {
          let resData = response.body.data;
          self.drawDailyChart(resData);
          self.loader7 = false;
          this.positionSOSTrendLineDataShow = response.body.data_present;
        })
        .catch((err) => {
          self.loader7 = false;
          console.log(err);
          console.log("err");
          this.positionSOSTrendLineDataShow = false;
        })
        .finally(() => {
          self.loader7 = false;
        });
    },
    // corrected for position sov bar
    processSearchGraph(d, dataPresent) {
      let self = this;
      // let cat = d.sov_lite_category;
      // let categoryKey = [];
      // let categoryData = [];
      let searchData = [];
      let search = d.sov_lite_search;
      let searchKey = [];
      // let seriesData = [];
      let minPointLength = 0;
      // let color = { 1: "#d1c6db", 2: "#899efc", 3: "#fbc49b", 4: "#ff8084" };
      for (const [key, value] of Object.entries(search)) {
        // minPointLength += 5;
        // if (value == 0) {
        //   cat[key] = null;
        // }
        // if (search[key] == 0) {
        //   search[key] = null
        // }
        // categoryKey.push("Page " + key);
        // categoryData.push(cat[key]);
        searchData.push(search[key]);
        searchKey.push("Page " + key);
        // let obj = {
        //   name: "Page " + key,
        //   data: [categoryData, searchData],
        //   color: color[key],
        //   borderWidth: 0,
        //   minPointLength: minPointLength,
        // };
        // seriesData.push(obj);
      }

      self.searchGraph = {
        chart: {
         type: "column",
          height: 380,
          marginTop: 50,
          marginBottom: 40,
          inverted: true,
          // height: searchKey.length * 50,
        },
        credits: {
          enabled: false,
        },
        exporting: {
          enabled: false,
        },
        title: {
          text: "",
        },
        xAxis: {
          opposite: false,
          categories: searchKey,
          crosshair: true,
          // categories: [
          //       self.selectedItemCategory.value + " category page",
          //     self.selectedItemCategory.value + " search page",
          // ],
          labels: {
            x: -22,
            style: {
              color: "#a1a1a1",
              fontFamily: "Heebo",
              fontWeight: 400,
              fontSize: "14px",
              // letterSpacing: '1px',
              // margin: 100
            },
          },
        },
        yAxis: {
          min: 0,
          max: 100,
          tickInterval: 25,
          title: {
            text: "",
          },
          labels: {
            y: 28,
            style: {
              color: "#a1a1a1",
              fontFamily: "Heebo",
              fontWeight: 400,
              fontSize: "14px",
              // letterSpacing: '1px',
            },
          },
          gridLineDashStyle: "longdash",
          lineColor: "rgba(228, 237, 238, 1)",
          lineWidth: 2,
        },
        tooltip: {
          formatter: function () {
            // var mytooltip = this.points[0].key + "<br/>";
            var mytooltip = "";
            for (var i = 0; i < this.points.length; i++) {
              mytooltip +=
                '<span style="color:' +
                this.points[i].series.color +
                '">\u25CF</span> ';
              mytooltip += "&nbsp;" + self.format(this.points[i].y) + "%";
              mytooltip += "<br/>";
            }
            return mytooltip;
          },
          // enabled: true,
          useHTML: true,
          shared: true,
          borderWidth: 1,
          borderColor: "rgba(212, 212, 212, 1)",
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 15,
          backgroundColor: "#ffffff",
          style: {
            fontSize: "16px",
          },
          padding: 10,
        },
        legend: {
          layout: "vertical",
          floating: true,
          align: "right",
          y: -10,
          x: 0,
          verticalAlign: "top",
          itemStyle: {
            fontFamily: "Poppins",
            fontWeight: 600,
            color: "#a1a1a1",
            fontSize: "14px",
            letterSpacing: "1px",
            textTransform: "capitalize",
          },
          itemHoverStyle: {
            color: "#065559", // Hover color
          },
          itemMarginTop: 0,
          itemMarginBottom: 0,
        },
        plotOptions: {
          column: {
            // stacking: "percent",
            // borderRadius: 4,
            pointPadding: 0.2, // Adds space between columns
            groupPadding: 0.1, // Extra spacing between groups if you have multiple series
            pointWidth: 25,
            borderWidth: 0,
            dataLabels: {
              enabled: false,
              formatter: function () {
                return this.point.y + "%";
              },
              // formatter: function () {
              //   return (
              //     '<span style="font-size:12px;font-weight:bold;padding:4px">' +
              //     self.format(this.points[i].y) +
              //     "% </span>"
              //   );
              // },
            },
          },
        },
        series: [
          // {
          //     name: self.selectedItemCategory.value + " " + "Category",
          //     data: categoryData,
          //     color: "#46A493",
          //     minPointLength: minPointLength,
          //     className: "colChartRadius",
          // },
          {
            name: self.selectedItemCategory.value + " " + "",
            data: searchData,
            // color: "#FCB117",
            color: "#46A493",
            minPointLength: minPointLength,
            className: "colChartRadius",
          },
        ],
      };
      self.positionSosBarDataShow = dataPresent;
    },
    //corrected for position sov done
    getPageDistribution() {
      var self = this;
      self.loader8 = true;
      self.positionSosBarDataShow = false;
      const url = "/api/v3/india_clients/page_distribution";
      let payload = {
        website: self.selected_website_sos.platform_link,
        start_date: moment(self.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(self.dateRange.endDate).format("YYYY-MM-DD"),
        item_category: self.selectedItemCategory.key,
        client: self.customClient,
        feature: "search",
        sub_category: self.storeSubCategory.selectedSubCategory,
        brand_name: self.storeSelectedBrandName
          ? self.storeSelectedBrandName.key
          : [],
      };
      this.$http
        .post(url, payload)
        .then((response) => {
          self.loader8 = false;
          let resData = response.body.data.data;
          // console.log(resData)
          self.processSearchGraph(resData, response.body.data_present);
        })
        .catch((err) => {
          self.loader8 = false;
          console.log(err, "err");
          // console.log("err");
          self.positionSosBarDataShow = false;
        })
        .finally(() => {
          self.loader8 = false;
        });
    },

    // corrected for Category SOV
    sos() {
      let self = this;
      // self.activeChart = false;
      self.loader9 = true;
      self.searchSosDataShow = false;
      const url = "/api/v3/india_clients/sov";
      let payload = {
        website: self.selected_website_sos.platform_link,
        start_date: moment(self.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(self.dateRange.endDate).format("YYYY-MM-DD"),
        item_category: self.selectedItemCategory.key,
        brand_name: self.storeSelectedBrandName
          ? self.storeSelectedBrandName.key
          : [],
        feature: "search",
        sub_category: self.storeSubCategory.selectedSubCategory,
        language: this.$store.state.DemoStore.selectedLanguage.key,

        // client: self.customClient,
      };
      this.$http
        .post(url, payload)
        .then((response) => {
          self.loader9 = false;
          self.barSOS(response.body.data, response.body.data_present);
        })
        .catch((err) => {
          self.loader9 = false;
          console.log(err, "err");
          // console.log("err");
          self.searchSosDataShow = false;
        })
        .finally(() => {
          self.loader9 = false;
        });
    },
    // corrected for Category SOV bar done
    barSOS(d, dataPresent) {
      let self = this;
      self.loader = false;
      let textCat =
        "Page 1 Count: " +
        d.total_count_single_page +
        "<br/>Pages 1-4 Count: " +
        d.total_count_all_page;
      self.charts = {
        credits: {
          enabled: false,
        },
        chart: {
          type: "column",
          height: 250,
          inverted: true,
          marginTop: 60,
          marginBottom: 65,
        },
        title: {
          text: "",
        },
        exporting: {
          enabled: false,
        },
        subtitle: {
          align: "left",
          text: textCat,
          style: {
            fontFamily: "Poppins",
            fontWeight: 600,
            color: "#a1a1a1",
            fontSize: "14px",
            letterSpacing: "1px",
          },
          verticalAlign: "top",
          align: "left",
          x: -8,
          y: 15,
        },
        yAxis: {
          title: {
            text: "Percentage %",
            y: 8,
            style: {
              color: "#a1a1a1",
              fontFamily: "Heebo",
              fontWeight: 400,
              fontSize: "14px",
              letterSpacing: "1px",
            },
          },
          labels: {
            y: 28,
            style: {
              color: "#a1a1a1",
              fontFamily: "Heebo",
              fontWeight: 400,
              fontSize: "14px",
              // letterSpacing: '1px',
            },
          },
          max: 100,
          tickInterval: 25,
          gridLineDashStyle: "longdash",
          lineColor: "rgba(228, 237, 238, 1)",
          lineWidth: 2,
        },
        legend: {
          layout: "vertical",
          floating: true,
          align: "right",
          y: -10,
          x: 0,
          verticalAlign: "top",
          itemMarginTop: 0,
          itemMarginBottom: 0,
          itemStyle: {
            fontFamily: "Poppins",
            fontWeight: 600,
            color: "#a1a1a1",
            fontSize: "14px",
            letterSpacing: "1px",
            y: 16,
          },
        },
        plotOptions: {
          column: {
            borderRadius: 3,
            dataLabels: {
              enabled: false,
              color: "black",
              inside: false,
              formatter: function () {
                return this.farmatethis.point.y + "%";
              },
            },
          },
        },
        plotOptions: {},
        xAxis: {
          categories: ["sos"],
          title: {
            text: "SOS",
            x: -10,
            style: {
              color: "#a1a1a1",
              fontFamily: "Heebo",
              fontWeight: 400,
              fontSize: "14px",
              letterSpacing: "1px",
              // margin: 100
            },
          },
          labels: {
            enabled: false,
          },
          crosshair: true,
        },
        tooltip: {
          formatter: function () {
            // var mytooltip = this.points[0].key + "<br/>";
            var mytooltip = "";
            for (var i = 0; i < this.points.length; i++) {
              mytooltip +=
                '<span style="color:' +
                this.points[i].series.color +
                '">\u25CF</span> ';
              // mytooltip += this.points[i].series.name;
              mytooltip += "&nbsp;&nbsp;" + self.format(this.points[i].y);
              if (this.points[0].key != -1) mytooltip += "%";
              mytooltip += "<br/>";
            }
            return mytooltip;
          },
          useHTML: true,
          shared: true,
          borderWidth: 1,
          borderColor: "rgba(212, 212, 212, 1)",
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 15,
          backgroundColor: "#ffffff",
          style: {
            fontSize: "16px",
          },
          padding: 10,
        },
        series: [
          {
            name: "Page 1",
            data: [d.percentage_single_page],
            allData: [d],
            color: "#5fc2b0",
            className: "chartRadius",
          },
          {
            name: "Page 1-4",
            data: [d.percentage_all_page],
            color: "#065559",
            allData: [d],
            className: "chartRadius",
          },
        ],
      };

      self.searchSosDataShow = dataPresent;
      // });
    },

    // get All Brands
    getAllBrandsFromApi(getValue) {
      let self = this;
      self.getbrandLoader = true;
      const url = "/api/v3/india_clients/sov_brand_list";
      let payload = {
        website: self.selected_website_sos.platform_link,
        start_date: moment(self.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(self.dateRange.endDate).format("YYYY-MM-DD"),
        item_category: self.selectedItemCategory.key,
        sub_category: self.storeSubCategory.selectedSubCategory,
        feature: "search",
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };
      this.$http
        .post(url, payload)
        .then((response) => {
          self.getbrandLoader = false;
          // console.log(response.body.data, 'sdsd')
          // let resData = response.body.data;
          self.storeAllBrands = response.body.new_data;
          if (self.storeAllBrands.length != 0) {
            self.storeSelectedBrandName = self.storeAllBrands[0];
          } else {
            self.storeSelectedBrandName = "";
          }
          if (getValue) {
            self.getSectionWiseData();
          }
        })
        .catch((err) => {
          self.getbrandLoader = false;
          console.log(err);
          console.log("err");
        });
    },
    format(v) {
      return this.$options.filters.format(v);
    },

    handleTabPanel(data) {
      this.activeTab = data;
    },

    translateBrandNameinEn(word) {
      let match = this.storeAllBrands.find((item) => item.value === word);
      return match ? match.key : word;
    },
  },
  computed: {
    ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
    starStyles() {
      return (row) => {
        const starPercentage = (row.ratings / this.starTotal) * 100;
        const starPercentageRounded = `${(starPercentage / 10) * 10.2}%`;
        return {
          width: starPercentageRounded,
        };
      };
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.stars-outer {
  display: inline-block;
  position: relative;
  font-family: FontAwesome;
  color: #ccc;
}

.stars-outer::before {
  content: "\f006 \f006 \f006 \f006 \f006";
}

.stars-inner {
  position: absolute;
  top: 0;
  left: 0;
  white-space: nowrap;
  overflow: hidden;
  width: 0;
}

.stars-inner::before {
  content: "\f005 \f005 \f005 \f005 \f005";
  color: rgba(252, 177, 23, 1);
}

.tab-label {
  cursor: pointer;
  padding-bottom: 5px;
  transition: all 0.3s ease;
  font-size: 16px;
  font-weight: 500;
}

.tab-label.active {
  color: rgba(6, 85, 89, 1);
  border-bottom: 1px solid rgba(6, 85, 89, 1);
  font-weight: 600 !important;
}

.noData {
  border: 1px solid #fbb1b1;
  border-radius: 5px;
  padding: 10px;
  background: #fff7f7;
}

.lastUpdated {
  color: #065559;
  font-size: 15px;
  padding: 8px 15px;
  border: 1px solid var(--base_color-80);
  border-radius: 6px;
}

.custom-table {
  padding: 10px;
  margin: 10px;
}

.markitamd {
  background-color: #ffb9b9 !important;
}

.markitintel {
  background-color: #c7e0ff !important;
}

.markitsnap {
  background-color: #ffd0f5 !important;
}

.markitna {
  background-color: #edf2fb !important;
}

.markittek {
  background-color: #fff0ce !important;
}

.space-between-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;

  padding-bottom: 5px;
}

.space-between-header select {
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}

.space-between-header h3 {
  color: #4e4e4e;
  margin-bottom: 0;
  line-height: 31px;
}

.listing-custom {
  font-size: 18px;
  margin-bottom: 6px;
  text-align: center;
  width: 215px;
  background: #8a87e8;
}

.hint {
  cursor: pointer;
  background: #f5f5f5;
  color: #080808;
  padding: 3px;
  font-size: 9px;
}

.amd-legend {
  text-align: center;
  position: absolute;
  left: 15%;
  right: 15%;
  z-index: 999;
}

.amd-legend i {
  width: fit-content;
}

.amd-legend span {
  padding-left: 4px;
  font-size: 12px;
}

.legending {
  display: inline-block;
  margin-right: 19px;
}

#avgTable th,
#avgTable td {
  border: 1px solid #c8ced3 !important;
  text-align: left;
  font-size: 14px;
}

.sovdetails {
  float: right;
  height: 30px;
  margin: 0;
  border-radius: 0;
  font-size: 15px;
  padding: 7px;
  width: max-content;
  cursor: pointer;
  margin-left: 4px;
}

.selectedProduct {
  background: var(--base_color-80) !important;
  color: White !important;
}

.tr {
  text-transform: none;
  font-family: "poppins";
  font-weight: bolder;
  /* text-align: left; */
  border: 1px solid var(--base_color-20) !important;
  background: var(--secondary_competitor-10);
}

td:first-child {
  background: var(--secondary_competitor-10);
  font-size: 14px;
}

.custom-hr-scroll {
  overflow-x: scroll !important;
}

/* revamp  */
.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 12px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  margin-bottom: -12px !important;
  margin-top: -8px;
}

#sovindia4page {
  font-family: "Poppins", sans-serif !important;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .btn-outline-secondary.dropdown-toggle {
  color: #ffffff !important;
  background-color: var(--primary_brand-80) !important;
  border-color: var(--primary_brand-80) !important;
  line-height: 35px !important;
  padding: 0px 20px !important;
  border-radius: 5px !important;
  font-weight: 600 !important;
}

.btn-outline-secondary {
  line-height: 35px !important;
  /* border-radius: 5px; */
  color: var(--primary_brand) !important;
  background: var(--primary_brand-10) !important;
  border: 1px solid var(--primary_brand-10) !important;
  font-family: "poppins" !important;
  padding: 0px 20px !important;
}

.btn-group {
  background: var(--primary_brand-10) !important;
  border-radius: 5px !important;
  font-family: "poppins" !important;

  /* border: 1px solid var(--primary_brand-10); */
}

.datePickerBadge {
  margin-left: 6px;
  height: 35px !important;
  border: 1px solid #c5c5c5;
  border-right: none;
  display: flex;
  align-items: center;
  margin-right: -5px;
  z-index: 3;
  background: #fff;
  color: black;
  border-radius: 5px 0px 0px 5px;
  font-family: "poppins";
}

.borderBetween {
  border-bottom: 0.13rem solid #e1e1e1 !important;
  margin: 10px 0px !important;
}

.borderBetweenTab {
  border-bottom: 1px solid rgba(213, 213, 213, 1) !important;
  margin-bottom: 15px !important;
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.searchInput input {
  height: 35px !important;
  margin-right: -5px !important;
  font-size: 14px !important;
  border-color: var(--primary_brand-60) !important;
  font-family: "poppins";
}

.searchInput input::placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins" !important;
  font-size: 16px !important;
}

.searchInput input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.searchInput input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.searchInput input:focus {
  box-shadow: none !important;
  border-color: var(--primary_brand) !important;
  font-family: "poppins";
}

.searchIcon {
  /* height: 40px; */
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  font-family: "poppins";

  background-color: var(--primary_brand);
}

.searchIcon img {
  width: 25px;
  margin: 10px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg)
    brightness(103%) contrast(104%);
}

.inputBoxTitle {
  color: var(--primary_brand);
  font-size: 16px;
  margin-bottom: 5px;
  font-family: "poppins";
}

.productListCheckbox span {
  /* font-weight: 600; */
  font-family: "Poppins", sans-serif !important;
}

.eachProduct:hover {
  background: var(--base_color-20);
}

.noData {
  background: #fff7f7 !important;
}

.longHeadingWidth {
  width: calc(55% - 100px);
  /* font-size: 16px; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}

@media screen and (min-width: 768px) {
  .mycol {
    padding-right: 15px !important;
    padding-left: 15px !important;
  }

  .mycols:first-child {
    padding-right: 2px !important;
  }

  .mycols:last-child {
    padding-left: 2px;
  }

  .mycols:not(:first-child):not(:last-child) {
    padding-left: 2px;
    padding-right: 2px;
  }
}

.multiline-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<style>
/* .modal-title {
	font-weight: 600 !important;
	font-family: "poppins";
}

.modal-header {
	background: var(--primary_brand-20) !important;
	color: var(--base_color);
	border: none;
	font-family: "poppins";
	border-radius: 5px 0px 0px 0px !important;
}

.modal-header .close {
	color: black;
	text-shadow: none;
	position: absolute;
	top: -2px;
	right: -6px;
	font-size: 30px;
	background: var(--primary_brand-10);
	opacity: inherit;
	padding: 5px 10px;
	border-radius: 25px;
} */

.chartRadius.highcharts-series-0 rect {
  clip-path: inset(0% 0% -8px 0% round 12px);
}

.chartRadius.highcharts-series-1 rect {
  clip-path: inset(0% 0% -8px 0% round 12px);
}

.colChartRadius.highcharts-series-0 rect {
  clip-path: inset(0% 0% -8px 0% round 9px);
}

.colChartRadius.highcharts-series-1 rect {
  clip-path: inset(0% 0% -8px 0% round 9px);
}

.reviewedRanking {
  background-color: #fcb117;
  color: #fff;
  left: 6px;
  top: 6px;
  border-radius: 5px;
  box-shadow: 0px 4px 4px 0px #00000040;
  padding: 5px 15px !important;
}

.inSightsContainer {
  border-radius: 5px !important;
  border: 1px solid #d9d9d9;
}

.inSightsContainer > div:first-child {
  border-right: 1px solid #d9d9d9;
}

.insightsContent {
  font-weight: 400;
  font-size: 14px;
  color: #1e1e1e;
}

.thin-scrollerBar::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 6px;
  background: #ebedee;
}

.thin-scrollerBar::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}

.thin-scrollerBar::-webkit-scrollbar-thumb {
  border-radius: 6px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: #b3b2b9;
}

.thin-scrollerBar::-webkit-scrollbar-thumb:hover {
  background: #8b8d94;
  cursor: pointer;
}

p.insightsContent > span {
  font-weight: 600;
  font-size: 14px;
  color: #1e1e1e;
}

.borderCommonForTag {
  border: 1px solid #5e5e5e;
  font-family: "Heebo";
  border-radius: 5px !important;
  color: #5e5e5e;
}

/* .highcharts-tooltip {
	z-index: 9999;
} */

.highChartlegendColorHover:hover {
  color: #065559 !important;
}
</style>
